import 'css-chunk:src/app/containers/GuestHome/Programs/ProgramDetail.scss';export default {
  "ProgramDetail": "_ProgramDetail_1my4f_1",
  "header": "_header_1my4f_1"
};